__turbopack_context__.v({
  "filter": "video-module__VaKJhq__filter",
  "flexWrapper": "video-module__VaKJhq__flexWrapper",
  "root": "video-module__VaKJhq__root",
  "subtitle": "video-module__VaKJhq__subtitle",
  "title": "video-module__VaKJhq__title",
  "titleWrapper": "video-module__VaKJhq__titleWrapper",
  "videoMain": "video-module__VaKJhq__videoMain",
});
